import React, { Component } from "react";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import AuthAction from "../../../Redux/AuthRedux";
import IdleTimer from "react-idle-timer";
import dashboardImage from "../../../assets/img/dashboards.png";

import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import user from "../../masterData/user/user/user";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

class dashboard1 extends Component {
  constructor() {
    super();
    this.state = {
      timeout: 1000 * 100 * 9,
      isTimedOut: false,

      //penambahan untuk message
      popupMessage: false,
      message: "",
    };
    this.idleTimer = null;
  }

  createSubMenu = (val, link, icon, id) => {
    return (
      <NavLink id={id} to={link}>
        <div
          className="content"
          style={{

            
            borderWidth: 2,
            borderColor: "#000000",
            backgroundColor: "#E74C3C",
            borderStyle: "solid",
            borderRadius: 5,
            width: 235,
            height: 235,
            justifyContent: "space-evenly",
          }}
        >
          <div
            className="list"
            style={{
              marginTop: "35%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "#ffffff",
              
              alignContent: "center",
            }}
          >
            <div className="icn" style={{ marginRight: 10 }}>
              <i className={`${icon} fa-lg`}></i>
            </div>
            <div className="ttl">{val}</div>
            <div className="icn icn-right txt-site txt-right txt-12" />
          </div>
        </div>
      </NavLink>
    );
  };

  checkPermissionSubMenu = (valMenu, valSubmenu) => {
    //static response for the moment,
    //will be activated later when authorization is ready to use
    return true;
    for (let indexData in this.state.menuData) {
      let item = this.state.menuData[indexData];
      if (item.menuId === valMenu) {
        let listForm = item.listForm;
        for (let indexSubData in listForm) {
          let subItem = listForm[indexSubData];
          if (subItem.formId === valSubmenu) {
            return true;
          }
        }
        break;
      }
    }
    return false;
  };

  forceLogout = () => {
    localStorage.clear("name");
    localStorage.clear("token");
    localStorage.clear("persist:primary");
    this.props.authLogout();
  };

  componentDidMount() {}

  componentWillMount() {}

  // penambahan untuk message
  componentWillUnmount() {}

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }}></Redirect>;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  render() {
    let jwtToken = localStorage.getItem("token");
    if (R.isNil(this.props.auth.user) || R.isNil(jwtToken))
      return <Redirect to={{ pathname: "/" }}></Redirect>;
    return (
      <div className="main-content" style={{ backgroundColor: "#ffffff" }}>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this.onActive.bind(this)}
          onIdle={this.onIdle.bind(this)}
          onAction={this.onAction.bind(this)}
          debounce={250}
          timeout={this.state.timeout}
        />

        <div
          style={{
            justifyContent: "space-between",
            display: "flex",

            fontSize: "20px",          
            alignItems: "center",
          }}
        >
          {/* <img width="100%" src={dashboardImage} alt="" /> */}

          {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "User Management",
              "/home/dashUserManagement-matrix",
              "fa fa-lg fa-user",
              "btn_navigate_user-management"
            )}
          {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "Bank Management",
              "/home/dashBankManagement-matrix",
              "fa fa-lg fa-user",
              "btn_navigate_bank-management"
            )}
          {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "Master Varian",
              "/home/dashVarian-matrix",
              "fa fa-lg fa-user",
              "btn_navigate_varian"
            )}
        {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
          this.createSubMenu(
            "Branch Management",
            "/home/dashBranch-matrix",
            "fa fa-lg fa-user",
            "btn_navigate_branch"
          )}

        {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
          this.createSubMenu(
            "Receiving Units",
            "/home/dashRecUnit-matrix",
            "fa fa-download",
            "btn_navigate_rec-unit"
          )}
        {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
          this.createSubMenu(
            "Delivery",
            "/home/dashDelivery-matrix",
            "fa fa-truck",
            "btn_navigate_delivery"
          )}
        </div>
        <div
          style={{
            justifyContent: "space-between",
            display: "flex",
            marginTop: "10px",
            fontSize: "20px",
            alignContent: "center",
          }}
        >
          {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "Receiving Parts",
              "/home/dashRecPart-matrix",
              "fa solid fa-download",
              "btn_navigate_rec-part"
            )}
            {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "MSIC IN OUT",
              "/home/dashMSIC-matrix",
              "fa solid fa-download",
              "btn_navigate_msic"
            )}
            {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "Unit Movement",
              "/home/dashUnitMovement-matrix",
              "fa solid fa-truck",
              "btn_navigate_unit-movement"
            )}
            {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "Master Jasa",
              "/home/dashMasterJasa-matrix",
              "fa solid fa-user",
              "btn_navigate_master-jasa"
            )}
            {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "Master Warehouse",
              "/home/dashWarehouse-matrix",
              "fa solid fa-truck",
              "btn_navigate_warehouse"
            )}
            {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "Master Pit",
              "/home/dashPit-matrix",
              "fa solid fa-user",
              "btn_navigate_pit"
            )}
        </div>
        <div
          style={{
            justifyContent: "space-between",
            display: "flex",
            marginTop: "10px",
            fontSize: "20px",
            alignContent: "center",
          }}
        >
            {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "Master Voucher",
              "/master/voucher-matrix",
              "fa solid fa-user",
              "btn_navigate_voucher"
            )}
            {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
            this.createSubMenu(
              "Inventory",
              "/master/inventory-matrix",
              "fa solid fa-truck",
              "btn_navigate_inventory"
            )}
            </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
    sumApproval: () => dispatch(AuthAction.sumApproval()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(dashboard1);
